<template>
 <!-- top="10vh"  -->
    <div class="selectContractItem">
        <el-dialog title=""
            width="90%" 
            top="3vh"
            :visible.sync="dialogFlag"
            :close-on-click-modal="$root.dialogAutoClose" 
            :close-on-press-escape="$root.dialogAutoClose"
            :modal-append-to-body="false">
            <!-- <el-form :model="searchForm" :inline="true">
                <el-form-item label="招标类别：" class="noMarginBottom">
                    <el-select
                        :popper-append-to-body="false"
                        popper-class="select"
                        @change="handelSelectChangeFunc"
                        class="minWidth2"
                        size="mini"
                        v-model="searchForm.rootCategoryId"
                        placeholder="请选择">
                        <el-option
                            style="width: 100px;"
                            v-for="item in rootCategories"
                            :key="item.id"
                            :label="item.categoryName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select
                        @change="handelSelectChangeFunc1"
                        class="minWidth2"
                        size="mini"
                        v-model="searchForm.firstCategoryId"
                        placeholder="请选择">
                        <el-option
                            style="width: 100px;"
                            v-for="item in firstLevelCategories"
                            :key="item.id"
                            :label="item.categoryName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select
                        @change="handelSelectChangeFunc2"
                        class="minWidth"
                        size="mini"
                        v-model="searchForm.categoryId"
                        placeholder="请选择">
                        <el-option
                            style="width: 100px;"
                            v-for="item in secondLevelCategories"
                            :key="item.id"
                            :label="item.categoryName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="招标事项：" class="noMarginBottom">
                    <el-select
                    size="mini"
                        v-model="searchForm.matterName"
                        filterable
                        remote
                        clearable
                        reserve-keyword
                        @change="search"
                        placeholder="请输入招标事项"
                        :remote-method="remoteMethod"
                        :loading="loading">
                        <el-option
                        v-for="item in longRangeData"
                        :key="item.value"
                        :label="item.matterName"
                        :value="item.matterName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="事项描述：" class="noMarginBottom">
                    <el-input v-model.trim="searchForm.matterRequired"
                            size="mini"
                            class="minWidth"
                            placeholder="请输入事项描述"></el-input>
                </el-form-item>
                <el-form-item class="noMarginBottom">
                    <el-button type="primary" @click="search" size="mini">查询</el-button>
                    <el-button type="" @click="reset" size="mini">重置</el-button>
                </el-form-item>
            </el-form> -->
            <!-- border:1px solid #EBEEF5; -->
            <div style="width:100%;display:flex;height:615px;">
                <div style="width:49%; border:1px solid #EBEEF5;">
                    <!-- <priceTable ref="priceTable" @func="getMsgFormSon" @select="selectCheck" @selection-change="handleSelectionChange" @select-all="selectAll" :isSelection="true" :orderStatus="orderStatus" @addItem="addStatus"></priceTable> -->
                    <div style="height:35px;line-height:35px;text-align: center;border-bottom: 1px solid #EBEEF5; font-weight:bold;">
                        选择库内价格
                    </div>
                    <el-form :model="searchForm" :inline="true" style="margin-top:10px;">
                        <!-- <el-form-item label="招标类别：" class="noMarginBottom">
                            <el-select
                                :popper-append-to-body="false"
                                popper-class="select"
                                @change="handelSelectChangeFunc"
                                class="minWidth2"
                                size="mini"
                                v-model="searchForm.rootCategoryId"
                                placeholder="请选择">
                                <el-option
                                    style="width: 100px;"
                                    v-for="item in rootCategories"
                                    :key="item.id"
                                    :label="item.categoryName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select
                                @change="handelSelectChangeFunc1"
                                class="minWidth2"
                                size="mini"
                                v-model="searchForm.firstCategoryId"
                                placeholder="请选择">
                                <el-option
                                    style="width: 100px;"
                                    v-for="item in firstLevelCategories"
                                    :key="item.id"
                                    :label="item.categoryName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select
                                @change="handelSelectChangeFunc2"
                                class="minWidth"
                                size="mini"
                                v-model="searchForm.categoryId"
                                placeholder="请选择">
                                <el-option
                                    style="width: 100px;"
                                    v-for="item in secondLevelCategories"
                                    :key="item.id"
                                    :label="item.categoryName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="类别:">
                            <el-cascader
                                size="mini"
                                style="width:100px"
                                v-model="cascaderData"
                                :options="categoryTreeList"
                                collapse-tags
                                filterable
                                :props="{ expandTrigger: 'hover',multiple: true ,value:'id',label:'categoryName',children: 'children'}"
                                @change="handleChange">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="事项：" class="noMarginBottom">
                            <el-select
                            size="mini"
                            style="width:110px;"
                                v-model="searchForm.matterName"
                                filterable
                                remote
                                clearable
                                reserve-keyword
                                @change="search"
                                placeholder="招标事项"
                                :remote-method="remoteMethod"
                                :loading="loading">
                                <el-option
                                v-for="item in longRangeData"
                                :key="item.value"
                                :label="item.matterName"
                                :value="item.matterName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="描述：" class="noMarginBottom">
                            <el-input v-model.trim="searchForm.matterRequired"
                                    size="mini"
                                    style="width:110px;"
                                    placeholder="事项描述"></el-input>
                        </el-form-item>
                        <el-form-item class="noMarginBottom">
                            <el-button type="primary" @click="search" size="mini">查询</el-button>
                            <el-button type="" @click="reset" size="mini">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <div style="">
                        <priceTable ref="priceTable" @func="getMsgFormSon" @select="selectCheck" @selection-change="handleSelectionChange" @select-all="selectAll" :isSelection="true" :orderStatus="orderStatus" @addItem="addStatus"></priceTable>
                    </div>
                </div>
                <div style="width:49%;margin-left:2%;border:1px solid #EBEEF5;">
                    <!-- <priceTable :editable="!isReadOnly" ref="priceTableChoosed" :maxHeight="520" @deleteItem="changeStatus"></priceTable> -->
                    <div style="height:35px;line-height:35px;text-align: center;border-bottom:1px solid #EBEEF5;font-weight:bold;">
                        已选择列表
                    </div>
                    <div style="margin-top:10px;">
                        <order ref="order" :amountExclTax="amountExclTax" :amountWithTax="amountWithTax" @changeRegional="priceChoosed([])"/>
                    </div>
                    <div style="padding-top:10px;">
                        <priceTable :editable="!isReadOnly" ref="priceTableChoosed" :maxHeight="530" @deleteItem="changeStatus"></priceTable>
                    </div>
                </div>
            </div>
            
            <div style="text-align: right; margin-top:20px;">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="this.searchForm.pageNumber"
                    :page-sizes="[15,30,45]"
                    :page-size="searchForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dataCount">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFlag = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="confirm" size="mini">确 认</el-button>
            </div>
            <!-- <div style="margin-bottom:10px;">
                已选择
            </div> -->
            
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue'
import priceTable from './priceTable';
export default Vue.component('priceChooseDialog', {
    //import引入的组件需要注入到对象中才能使用
    components: {priceTable},
    computed: {
        isReadOnly(){
            if(this.type == 1 || this.type == 2){
                return true;
            }else {
                return false;
            }
        },
        amountExclTax(){
            let sum = 0;
            let tempTableData = this.multipleSelection;

            tempTableData.forEach(item => {
                if(item.quotationType == 1) {
                    let temp = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                    sum = this.$root.accAdd(sum, temp);
                }
            });
            return sum;
        },
        amountWithTax(){
            let sum = 0;
            let tempTableData = this.multipleSelection

            tempTableData.forEach(item => {
                if(item.quotationType == 1){
                    let temp = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                    sum = this.$root.accAdd(sum, temp);
                }
            });
            return sum;
        },
        orderStatus() {
            if (this.orderStatusType == 0) {                  
                return this.orderStatusType
            } else if (this.orderStatusType == 3){
                return this.orderStatusType
            }else {
                return null;
            }
        },
        // taxRatioAmount () {
        //     let temp = this.$root.accMinus(amountExclTax, amountWithTax);
        //     // let sum = 0;
        //     let tempTableData = this.multipleSelection

        //     tempTableData.forEach(item => {
        //         if(item.quotationType == 1){

        //             let temp = this.$root.accMinus(item.amountExclTax, item.amountWithTax);
        //         }
        //     });
        //     return temp;
        // }
    },
    data() {
        return {
            cascaderData: '',
            categoryTreeList: [],
            longRangeData: [], //远程搜索值
            searchData: [],
            loading: false,
            dialogFlag: false,
            orderStatusType: '',
            // searchForm: {
            //   regionalCompanyId: '',
            //   matterName: '',
            //   matterRequired: '',
            //   rootCategoryId: '',
            //   firstCategoryId: '',
            //   categoryId: '',

            //   priceLibraryType: 1,
            //   pageFlag: 1,
            //   pageNumber: 1,
            //   pageSize: 5,
            // },
            searchForm: {
              regionalCompanyId: '',
              matterName: '',
              rootCategoryId: '',
              categoryArr: [],
              firstCategoryId: '',
              categoryId: '',
              currentPrice: true,
              suppliersId: window.sessionStorage.getItem('loginId'),
              matterRequired: '',
              priceLibraryType: 1,
              pageFlag: 1,
              pageNumber: 1,
              pageSize: 15,
              companyId: ''
            },
            tableData: [],
            dataCount: 0,

            multipleSelection: [],
            rootCategories: [],
            firstLevelCategories: [],
            secondLevelCategories: [],

            category: {},
            multipleSelectionOld: [],
        }
    },
    //方法集合
    methods: {
        //获取供方分类完整树形数据
        getTreeList(){
            this.$root.postFunc('/v1/sSuppliersCategory/public/findSuppliersCategoryTreeList',{
                "categoryStatus": '',
                "pageFlag": 0,
                "pageNumber": 0,
                "pageSize": 0
            },(res)=> {
                // console.log(res)
                this.categoryTreeList = res.data.data.tree;
            });
        },
        handleChange(value) {
            let data = []
            value.map((item)=>{
                data.push(item[2])
            })
            this.searchForm.categoryArr = data
            // console.log(data)
            if (value.length != 0) {
                this.searchForm.matterName = '',
                this.searchForm.matterRequired = ''
            }
        },
        // 加号给已选择列表push数据
        getMsgFormSon(data){
            let newData = JSON.parse(JSON.stringify(data))
            this.multipleSelection.push(newData)
            let priceTableChoosedRef = this.$refs['priceTableChoosed'];
            if(priceTableChoosedRef){
                priceTableChoosedRef.setData(this.multipleSelection, this.category);
            }
            // this.$set(this.multipleSelection, this.multipleSelection.length, data)
        },
        // 远程搜索
        remoteMethod(query) {
            if (query !== '') {
              this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.longRangeData = this.searchData.filter(item => {
                        return item.matterName.indexOf(query) > -1
                    })
                }, 200)
            } else {
                this.longRangeData = [];
            }
        },
        //  选择搜索列表
        getLang(){
            if (this.searchForm.categoryArr.length == 0) {
                // console.log( this.categoryId)
                let obj = {
                    regionalCompanyId: this.searchForm.regionalCompanyId,
                    matterName: this.searchForm.matterName,
                    rootCategoryId: this.searchForm.rootCategoryId,
                    firstCategoryId: this.searchForm.firstCategoryId,
                    categoryId: '101033',
                    currentPrice: true,
                    suppliersId: window.sessionStorage.getItem('loginId'),
                    matterRequired: this.searchForm.matterRequired,
                    priceLibraryType: 1,
                    companyId: this.searchForm.companyId,
                    categoryArr: this.searchForm.categoryArr,
                    // categoryArr: [101033]
                }
                this.$root.postHttp('/v1/sPriceLibraryClauses/searchList', obj,  (res)=> {
                    this.searchData = res.data.data
                })
            } else {
                let obj = {
                    regionalCompanyId: '',
                    matterName: this.searchForm.matterName,
                    rootCategoryId: '',
                    firstCategoryId: '',
                    categoryId: '',
                    currentPrice: true,
                    suppliersId: window.sessionStorage.getItem('loginId'),
                    matterRequired: this.searchForm.matterRequired,
                    priceLibraryType: 1,
                    companyId: this.searchForm.companyId,
                    categoryArr: this.searchForm.categoryArr
                }
                this.$root.postHttp('/v1/sPriceLibraryClauses/searchList', obj,  (res)=> {
                    this.searchData = res.data.data
                })
            }
            
            
        },
        handelSelectChangeFunc() {
            this.firstLevelCategories = [];
            this.secondLevelCategories = [];
            this.searchForm.firstCategoryId = '';
            this.searchForm.categoryId = '';

            this.getFirstLevels((data)=>{
                if(data&&data.length){
                    this.searchForm.firstCategoryId = data[0].id
                    this.getSecondLevels((data)=>{
                        if(data&&data.length)
                            this.searchForm.categoryId = data[0].id
                            this.category = data[0]
                    });
                }
            });
        },
        handelSelectChangeFunc1() {
            this.secondLevelCategories = [];
            this.searchForm.categoryId = '';

            this.getSecondLevels((data)=>{
                if(data&&data.length){
                    this.searchForm.categoryId = data[0].id
                    this.category = data[0]
                }
                   
            });
        },
        handelSelectChangeFunc2() {
            this.category = {
                'parentCategoryCode':'',
                'categoryCode':''
            }
        },
        addStatus(){

        },
        changeStatus() {
            let that = this;
            let priceTableRef = that.$refs['priceTable'];
            // console.log(priceTableRef)
                if(priceTableRef){
                    // console.log(priceTableRef)
                    let selectedObjs = [];
                    that.multipleSelection.forEach(obj => {
                        let findObj = that.tableData.find((item) => {
                            if (item.priceLibraryClausesId == obj.priceLibraryClausesId) 
                            return item;
                        });
                        selectedObjs.push(findObj);
                    });
                    that.$nextTick(()=>{
                        if (priceTableRef.$refs.tableData1) {
                            priceTableRef.$refs.tableData1.clearSelection()
                        } else if (priceTableRef.$refs.tableData3) {
                            priceTableRef.$refs.tableData3.clearSelection()
                        } else if (priceTableRef.$refs.tableData4) {
                            priceTableRef.$refs.tableData4.clearSelection()
                        } else if (priceTableRef.$refs.tableData5) {
                            priceTableRef.$refs.tableData5.clearSelection()
                        } else if (priceTableRef.$refs.tableData6) {
                            priceTableRef.$refs.tableData6.clearSelection()
                        } else if (priceTableRef.$refs.tableData7) {
                            priceTableRef.$refs.tableData7.clearSelection()
                        } else if (priceTableRef.$refs.tableData8) {
                            priceTableRef.$refs.tableData8.clearSelection()
                        } else if (priceTableRef.$refs.tableData9) {
                            priceTableRef.$refs.tableData9.clearSelection()
                        } else if (priceTableRef.$refs.tableData10) {
                            priceTableRef.$refs.tableData10.clearSelection()
                        } else if (priceTableRef.$refs.tableData11) {
                            priceTableRef.$refs.tableData11.clearSelection()
                        } else if (priceTableRef.$refs.tableData12) {
                            priceTableRef.$refs.tableData12.clearSelection()
                        }
                        
                        priceTableRef.toggleSelection(selectedObjs);
                    })
                }
        },
        selectAll(selection){
            // console.log(selection,'22222')
            if(selection.length == 0){
                let ids = this.tableData.map(item => {
                    return item.priceLibraryClausesId;
                })
                this.multipleSelection = this.multipleSelection.filter(item => {
                    return ids.indexOf(item.priceLibraryClausesId) == -1;
                })
                let priceTableChoosedRef = this.$refs['priceTableChoosed'];
                if(priceTableChoosedRef){
                    priceTableChoosedRef.setData(this.multipleSelection, this.category);
                }
            }
        },
        selectCheck(selection, row){
            // console.log(selection, row,'33333')
            let findObj = selection.find((item) => {
                if (item.priceLibraryClausesId == row.priceLibraryClausesId) return item;
            });
            if(!findObj){
                this.multipleSelection = this.multipleSelection.filter(item => {
                    return item.priceLibraryClausesId != row.priceLibraryClausesId;
                })
                let priceTableChoosedRef = this.$refs['priceTableChoosed'];
                if(priceTableChoosedRef){
                    priceTableChoosedRef.setData(this.multipleSelection, this.category);
                }
            }
        },
        handleSelectionChange(val) {
            // console.log(val,'1111111111')
            for (let i = 0; i < val.length; i++) {
                let obj = val[i];
                if (obj === undefined) continue
                let findObj = this.multipleSelection.find((item) => {
                    if (item.priceLibraryClausesId == obj.priceLibraryClausesId) return item
                    // if (item.dealListStatus == 1)  return item;
                })
                if(!findObj){
                    this.multipleSelection.push(obj)
                }
            }

            let priceTableChoosedRef = this.$refs['priceTableChoosed'];
            if(priceTableChoosedRef){
                priceTableChoosedRef.setData(this.multipleSelection, this.category);
            }
        },
        getCategory(categoryId='', fn){
            let that = this;
            that.$root.postHttp('/v1/sSuppliersCategory/public/findSuppliersCategoryListByParent', {'categoryId': categoryId}, function (res) {
                fn && fn(res.data.data);
            })
        },
        getFirstLevels(fn){
            this.getCategory(this.searchForm.rootCategoryId, (data)=>{
                this.firstLevelCategories = data;
                fn && fn(data);
            })
        },
        getSecondLevels(fn){
            this.getCategory(this.searchForm.firstCategoryId, (data)=>{
                this.secondLevelCategories = data;
                fn && fn(data);
            })
        },
        search(){
            this.multipleSelectionOld = this.multipleSelection
            if (this.categoryId != this.searchForm.categoryId) {
                let priceTableChoosedRef = this.$refs['priceTableChoosed'];
                if(priceTableChoosedRef){
                    priceTableChoosedRef.setData(this.multipleSelection, this.category);
                }
            } else if (this.categoryId == this.searchForm.categoryId && this.multipleSelectionOld.length > 0) {
                this.multipleSelection = this.multipleSelectionOld
                let priceTableChoosedRef = this.$refs['priceTableChoosed'];
                if(priceTableChoosedRef){
                    priceTableChoosedRef.setData(this.multipleSelection, this.category);
                }
            }

            this.searchForm.pageNumber = 1;
            this.getData();
            this.getLang()
        },
        // 重置
        reset() {
            // console.log(this.searchForm.categoryId)
            this.searchForm.matterName = ''
            this.searchForm.matterRequired = ''
            this.cascaderData = '',
            this.searchForm.categoryArr = []
            this.getData()
            this.getLang()
        },
        confirm() {
            if (this.multipleSelection.length == 0) {
                this.$alert('请选择清单', {
                    type: 'warning'
                });
                return;
            }
            this.dialogFlag = false;
            this.$emit('callback', this.multipleSelection);
        },
        handlePageChange(val) {
            let that = this;
            that.searchForm.pageNumber = val;
            that.getData();
        },
        handleSizeChange(val) {
            let that = this;
            that.searchForm.pageSize = val;
            that.getData();
        },
        getData() {
            let that = this;
            if (this.searchForm.categoryArr.length == 0) {
                // this.searchForm = this.searchForm
                this.searchForm.categoryId = '101033'
                // this.searchForm.categoryArr = [101033]
            } else {
                this.searchForm.regionalCompanyId = '',
                this.searchForm.matterName = '',
                this.searchForm.rootCategoryId= '',
                this.searchForm.firstCategoryId= '',
                this.searchForm.categoryId= ''
            }
            that.$root.postHttp('/v1/sPriceLibraryClauses/searchList', this.searchForm, function (res) {
                if(res.data.data){
                    that.tableData = res.data.data.list || []
                    // that.tableData.forEach(item => {
                    //     console.log(item.id)
                    // 　　that.$set(item,'dealListStatus', 1)
                    // })
                    let priceTableRef = that.$refs['priceTable'];
                    if(priceTableRef){
                        let selectedObjs = [];
                        that.multipleSelection.forEach(obj => {
                            let findObj = that.tableData.find((item) => {
                                if (item.priceLibraryClausesId == obj.priceLibraryClausesId) return item;
                            });
                            selectedObjs.push(findObj);
                        })
                        priceTableRef.setData(that.tableData, that.category,that.multipleSelection);
                        // that.$nextTick(()=>{
                        //     priceTableRef.toggleSelection(selectedObjs);
                        // })
                        priceTableRef.toggleSelection(selectedObjs);
                    }

                    let priceTableChoosedRef = that.$refs['priceTableChoosed'];
                    priceTableChoosedRef.setData(that.multipleSelection, that.category);
                    // 先注释一下，测试
                    // if(priceTableChoosedRef){
                    //     if(that.multipleSelection.length == 0){
                    //         priceTableChoosedRef.setData([], that.category);
                    //     }
                    // }
                    let orderRef = that.$refs['order']
                        // console.log(that.$refs['order'])
                        if (orderRef) {
                            orderRef.order = that.$refs['order']
                            orderRef.order.taxRatioAmount = (that.$refs['order'].amountWithTax - that.$refs['order'].amountExclTax).toFixed(2)
                        }
                    that.dataCount = res.data.data.count;
                }
            });
        },
        show(categoryObj, companyId,areaId,orderStatusType) {
            // console.log(categoryObj)
            this.searchForm.regionalCompanyId = areaId;
            // console.log('222222222222333333333333',this.multipleSelection)
            this.searchForm.rootCategoryId = categoryObj.grandParentCategoryId;
            this.searchForm.firstCategoryId = categoryObj.parentCategoryId;
            this.searchForm.categoryId = categoryObj.categoryId;
            this.searchForm.companyId = companyId
            this.orderStatusType = orderStatusType
            this.dialogFlag = true;
            this.multipleSelectionOld = []
            // console.log('查看id',this.searchForm.categoryId)
            this.getTreeList()
            this.getCategory('', (data)=>{
                this.rootCategories = data;
                if (this.searchForm.rootCategoryId == null || this.searchForm.rootCategoryId.length == 0) {
                    // 默认物料
                    // this.searchForm.rootCategoryId = this.rootCategories[1].id
                    // 默认工程类
                    this.searchForm.rootCategoryId = this.rootCategories[0].id
                }
                this.getFirstLevels(()=>{
                    if (this.searchForm.firstCategoryId == null || this.searchForm.firstCategoryId.length == 0) {
                        this.searchForm.firstCategoryId = this.firstLevelCategories[0].id
                    }

                    this.getSecondLevels(()=>{
                        if (this.searchForm.categoryId == null || this.searchForm.categoryId.length == 0) {
                            this.category = this.secondLevelCategories[0];
                            // 默认物料第一个
                            // this.searchForm.categoryId = this.secondLevelCategories[0].id;
                            // 默认零星工程
                            this.searchForm.categoryId = this.secondLevelCategories[32].id;
                        } else {
                            this.category = this.secondLevelCategories.filter(item => {
                                // console.log(item,'11111')
                                return item.id == this.searchForm.categoryId;
                            })[0]
                        }
                        // console.log("this.category", this.category);

                        this.categoryId = this.category.id
                        // this.searchForm.categoryArr.push(this.categoryId)
                        // console.log('categoryId',this.categoryId)
                        this.search();
                    });
                });

            });
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    watch:{
        dialogFlag(val){
            if(val){
                this.$root.addClass(document.getElementsByClassName('main-wrap')[0],"noscroll")
            }else{
                this.$root.removeClass(document.getElementsByClassName('main-wrap')[0],"noscroll")
            }
        }
    }
})
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类

@import '../../../assets/_var.scss';
/deep/ .el-dialog__body {
    padding: 5px 15px !important;
}
/deep/ .el-dialog__header {
    padding: 5px;
}
/deep/ .el-cascader__search-input {
    width: 0;
    min-width: 0;
    margin: 0 0 0 10px;
}
/deep/ .el-tag--mini {
    padding: 0 1px;
}
/deep/ .el-input--mini .el-input__inner {
    height: 30px !important;
}
/deep/ .el-cascader__tags {
    position: absolute;
    top: 50%;
    display: flex;
    flex-wrap: nowrap;
}
/deep/ .el-cascader__tags .el-tag {
    max-width: 85%;
}
// .select {
    
// }
/deep/ .el-select-dropdown {
        min-width: 110px;
        transform-origin: center top;
        z-index: 2014;
        // margin-top: 110px !important;
        position: absolute;
        top: 15px;
        // left: 187px;
}
.selectContractItem /deep/ {
    .el-dialog__body {
        // padding: 10px 15px !important;
        color: #606266;
        line-height: 24px;
        font-size: 14px;
    }
    .minWidth{
        width: 150px;
    }
    .minWidth2{
        width: 110px;
    }
    select{
        border: 1px solid #C4C4C4;
        border-radius: 3px;
        height: 25px;
    }
    .el-input__inner{
        border: 1px solid #C4C4C4;
        border-radius: 3px;
        position: relative;
    }

    .el-form-item__label, .el-form-item__content{
        line-height: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/components/priceChooseDialog.vue